<div class="ct-other-locs-container" *ngIf="nearSubHurbs?.length > 0">
  <h2>Browse Locations in Melbourne</h2>
  <ul class="ct-other-locs">
    <ng-container *ngFor="let location of nearSubHurbs; let i = index">
      <li>
        <a (click)="setLocation(location)" [routerLink]="fetchSubUrbURL(location)" title="{{category | slugText : 'capitalize'}} in {{location.city}}">{{category | slugText : 'capitalize'}} in {{location.city}}</a>
      </li>
    </ng-container>
  </ul>
</div>